import {StageService} from '../stage.service';
import {Injectable} from '@angular/core';
declare let THREE: any;

export type ObjectSelector = (object) => boolean;

@Injectable()
export class MaterialDepthSwitcher {

  constructor(
    private StageSrvc: StageService
  ) {

  }

  private static isMesh = (object) => object instanceof THREE.Mesh;

  private toggleMaterialDepth(predicate: ObjectSelector, enable: boolean) {
    const objects = this.StageSrvc.getChildrenByPredicate(predicate);
    objects.forEach(obj => {
      obj.traverse(child => {
        if (MaterialDepthSwitcher.isMesh(child)) {
          child.material.depthTest = enable;
          child.material.needsUpdate = true;
        }
      });
    });
  }

  turnOff(predicate: ObjectSelector) {
    this.toggleMaterialDepth(predicate, false);
  }

  turnOn(predicate: ObjectSelector) {
    this.toggleMaterialDepth(predicate, true);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/material/material-depth-switcher.service.ts